$(document).ready(function () {
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

      if (scroll >= 50) {
         $(".makeHeaderSticky").addClass("enableStickyHeader");
      } else {
      $(".makeHeaderSticky").removeClass("enableStickyHeader");
    }
    
    if (scroll >= 105) {
      $(".stickyMobileHeader").addClass("activeSticky");
    } else {
      $(".stickyMobileHeader").removeClass("activeSticky");
    }
  });


   $(".dummySelector").click(function () {
    $(this).parent(".fakeSelector").toggleClass("activeDropDown");
  });


    $(".dropOptionBtn").click(function () {
    let dataVal = $(this).attr("data-val");
    let selectId =  $(this).parent(".myDropDown").attr("dataId");
    $(selectId).val(dataVal).trigger("change");
       let activeTxt = $(this).text();
      
$(this).parent(".myDropDown").prev(".dummySelector").children(".selectedItem").text(activeTxt);
      
       $(".fakeSelector").removeClass("activeDropDown");
   
    // $(this).addClass("activeSort");
    // var activeTxt = $(this).text();
    // console.log(activeTxt);
    // $("#sortActiveTxt").text(activeTxt);
    // $(".mobileFilterAndSortBtn").removeClass("ActiveSortDropDown");
  });
  
});
